/**
 * Validates a single field in the Physician Details form.
 * @param {string} name - Field name
 * @param {string} value - Field value
 * @returns {string|null} - Error message or null if valid
 */
export const validatePhysicianField = (name, value) => {
  if (["physicianFirstName", "physicianLastName", "npi"].includes(name)) {
    if (!value?.trim()) {
      return `${name.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())} is required`;
    }
  }

  return null;
};

/**
 * Validates the entire Physician Details form data.
 * @param {object} data - Physician details data
 * @returns {object} - Object containing errors for each field
 */
export const validatePhysicianForm = (data) => {
  const errors = {};
  const fields = [
    "physicianFirstName",
    "physicianLastName",
    "npi",
    "phone",
    "fax",
  ];

  fields.forEach((field) => {
    const error = validatePhysicianField(field, data[field] || "");
    if (error) errors[field] = error;
  });

  return errors;
};
